import { createSlice } from '@reduxjs/toolkit';
import camelize from 'camelize';
import userState from '../states/userState';
import {
  setDownloadedUser,
  setViewMode,
  updateUsers,
} from '../actions/userActions';

export const userSlice = createSlice({
  name: 'user',
  initialState: userState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setDownloadedUser, (state, action) => ({
      ...state,
      downloadedUser: action.payload
        ? {
            ...state.downloadedUser,
            ...camelize(action.payload),
          }
        : {},
    }));

    builder.addCase(updateUsers.pending, (state) => ({
      ...state,
      isUsersUpdating: true,
    }));

    builder.addCase(updateUsers.fulfilled, (state) => ({
      ...state,
      isUsersUpdating: false,
    }));

    builder.addCase(updateUsers.rejected, (state) => ({
      ...state,
      isUsersUpdating: false,
    }));

    builder.addCase(setViewMode, (state, action) => ({
      ...state,
      viewMode: action.payload,
    }));
  },
});
